import { render, staticRenderFns } from "./BaseDescDrawer.vue?vue&type=template&id=ed7ae522&scoped=true&"
import script from "./BaseDescDrawer.vue?vue&type=script&lang=js&"
export * from "./BaseDescDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed7ae522",
  null
  
)

export default component.exports